// STYLES AND BLOCKS
import "../styles/styles.css";
import "./common.js";

// LIBRARIES
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// ANIMATIONS
gsap.registerPlugin(ScrollTrigger);	
gsap.set(".reveal", { autoAlpha: 0, y: 20 });

ScrollTrigger.batch(".reveal", {
    start: "top 85%",
    once: true,
    onEnter: (els) =>
    gsap.to(els, { autoAlpha: 1, y: 0, duration: 0.8, ease: "power2.out", stagger: 0.1 }),
});

const menuTrigger = document.querySelector("#menu-trigger");
const mobileNav = document.querySelector("#nav-main-mobile");
const iconBurger = menuTrigger.querySelector(".icon-burger");
const iconClose = menuTrigger.querySelector(".icon-close");

menuTrigger.addEventListener("click", () => {
  // Toggle the active class on the nav
  const isActive = mobileNav.classList.toggle("active");

  // Toggle the visibility of the icons based on whether the nav is active
  iconBurger.classList.toggle("hidden", isActive);
  iconClose.classList.toggle("hidden", !isActive);
});
